
import React, { useEffect, useState} from "react";
import {useNavigate, useOutletContext, useSearchParams} from "react-router-dom";
import venifyLogo from "../../venifyLogo.png"
import Api from "../../tools/service";
import Container from "../../components/Container";
import LoadingScreen from "../../components/LoadingScreen";
import {MdAlternateEmail} from "react-icons/md";
import {TbWorldWww} from "react-icons/tb";
import WidgetRules from "./WidgetRules";

const EstateReports=()=>{
    const [token,setToken] = useOutletContext();
    const [info,setInfo]=useState();
    const [loading,setLoading]=useState(true)
    const [confirmDate,setConfirmDate]=useState()
    const [searchParams] = useSearchParams();
    const ref=searchParams.get('ref');
    const navigate=useNavigate();
 /*   useEffect(()=>{

        if(token){
            getReports()
        }
    },[token]);*/
    useEffect(() => {
        getReports()
    }, []);
    const getReports=()=>{
        setLoading(true)
        Api.get(`api/v1/Public/Estate/${ref}`,{
            params:{
                g_response:token,
            }
        }).then(response=>{

            if(!response.hasError){

                setInfo(response.data)
                const date = new Date(response.data.info.auth_date * 1000);
                const formatter = new Intl.DateTimeFormat('fa-IR', {
                    month:"long",
                    day:"numeric",
                    calendar:"persian",
                    year:"numeric"
                });
                setConfirmDate(formatter.format(date))
            }else{
                navigate('/notfound')
            }
        }).catch(e=>{

        }).finally(()=>{
            setLoading(false)
        })
    }
    if(loading){
        return  <LoadingScreen/>
    }
    return <div className="  ">

        <Container className="flex  font-sm rtl mt-20  items-center flex-col justify-center">
            <div dir="rtl" className="w-full  ">
                <div className=" items-center w-full mb-2 rounded-xl  flex bg-white p-5  ">
                    <a className="w-16" href="https://venify.ir">
                        <img className="w-16" src={venifyLogo} alt=""/>
                    </a>
                    <div className="flex mr-2 flex-col">
                        <a href="https://venify.ir">
                            <h1 className="text-xl    font-bold  ">ونیفای</h1>
                        </a>
                        <p className="  text-sm  "> ارائه دهنده سرویس‌های هوشمند مالی و بانکی در جهت سهولت و مجازی‌سازی
                            خدمات</p>
                    </div>
                </div>
                <div className="grid grid-cols-1 gap-2 lg:grid-cols-6">
                    {<div className="bg-white p-5 rounded-xl lg:col-span-2">
                        <div className=" flex mb-3  items-start md:items-center  w-full">
                            <h1 className="text-xl font-bold">استعلام سند ملکی</h1>
                        </div>
                        <div className="grid grid-cols-1  gap-2">
                            {info?.widget_body?.Area &&
                                <div className="flex justify-between  items-center     py-2 border-t  ">
                                    <span className="text-sm">مساحت  </span>
                                    <span className="text-sm font-bold">{info?.widget_body?.Area}</span>
                                </div>
                            }
                            {info?.widget_body?.PieceType &&
                                <div className="col-span-1  py-2 border-t flex justify-between     ">
                                    <span className="text-sm">نوع ملک  </span>
                                    <span className="text-sm font-bold">{info?.widget_body?.PieceType}</span>
                                </div>
                            }
                            {info?.widget_body?.StateType &&
                                <div className="col-span-1 py-2 border-t  flex justify-between      ">
                                    <span className="text-sm">وضعیت خاص  </span>
                                    <span className="text-sm font-bold">{info?.widget_body?.StateType}</span>
                                </div>
                            }
                            {info?.widget_body?.UsingType &&
                                <div className="col-span-1  items-center py-2 border-t  flex justify-between        ">
                                    <span className="text-sm">کابری  </span>
                                    <span className="text-sm font-bold">{info?.widget_body?.UsingType}</span>
                                </div>
                            }
                            {info?.widget_body?.HasRahn &&
                                <div className="flex col-span-1 w-full justify-between items-center  border-t   py-2 ">
                                    <span className="text-sm">رهنی </span>
                                    <span className="text-sm   font-bold">{info?.widget_body?.HasRahn}</span>
                                </div>
                            }
                            {info?.widget_body?.IsArrested &&
                                <div className="flex col-span-1 w-full justify-between items-center   border-t py-2  ">
                                    <span className="text-sm">بازداشتی  </span>
                                    <span className="text-sm  font-bold">{info?.widget_body?.IsArrested}</span>
                                </div>
                            }
                            {info?.widget_body?.OtherRestrict &&
                                <div className="flex  justify-between items-center  border-t py-2  ">
                                    <span className="text-sm">سایر محدودیت ها  </span>
                                    <span
                                        className="text-sm   font-bold">{info?.widget_body?.OtherRestrict}</span>
                                </div>
                            }
                            {(info?.widget_body?.im_owner !== undefined && info?.widget_body?.im_owner != null) &&
                                <div className="flex items-center py-2  border-t  justify-between">
                                    <span className="text-sm">آیا آگهی‌گذار مالک ملک است؟</span>
                                    {info?.widget_body?.im_owner &&
                                        <span className="text-green-500 text-sm">بله</span>}
                                    {!info?.widget_body?.im_owner &&
                                        <span className="text-red-500 text-sm">خیر</span>}

                                </div>}

                            {(info?.widget_body?.i_have_access_to_owner !== undefined && info?.widget_body?.i_have_access_to_owner != null) &&
                                <div className="flex items-center  py-2  border-t justify-between">
                                    <span className="text-sm">آیا آگهی‌گذار به مالک دسترسی دارد؟</span>
                                    {info?.widget_body?.i_have_access_to_owner &&
                                        <span className="text-green-500 text-sm">بله</span>}
                                    {!info?.widget_body?.i_have_access_to_owner &&
                                        <span className="text-red-500 text-sm">خیر</span>}

                                </div>}
                        </div>

                        <div
                            className="flex items-center  flex-col pt-3 mt-3  justify-between">

                            {info.btns.map((btn, index) => {
                                return <a href={btn.url} className="w-full" key={index}>
                                    <button className="p-3 btn btn-green   text-sm w-full  px-5 rounded-lg   ">
                                        {btn.title}
                                    </button>
                                </a>
                            })}
                        </div>
                    </div>}
                    <WidgetRules/>
                </div>

            </div>
            <div dir="rtl"
                 className="w-full    mt-4 text-sm      text-center flex justify-center items-center flex-col ">
                <div className="grid grid-cols-2 lg:grid-cols-2  w-full gap-3 ">
                    <div className=" p-5 col-span-1 bg-white flex justify-start items-center text-gray-800 rounded-xl">
                        <TbWorldWww className="text-xl"/>
                        <div className="flex  mr-3 flex-col items-start justify-start">
                        <p className="text-gray-800 mb-1">آدرس وبسایت</p>
                            <a href="https://venify.ir" className="text-gray-800 font-bold">https://venify.ir</a>
                        </div>
                    </div>
                    <div className=" p-5 col-span-1 bg-white flex justify-start  items-center text-gray-800 rounded-xl">
                        <MdAlternateEmail className="text-xl"/>
                        <div className="flex mr-3 flex-col items-start justify-start">
                            <p className="text-gray-700 text-sm mb-1">ایمیل</p>
                            <a href="mailto:info@venify.ir" className=" font-bold">info@venify.ir</a>
                        </div>
                    </div>
                </div>
                <div className="w-full border-t mt-5 "></div>
                <p className="mt-2 text-sm ">تمامی حقوق مربوط به این وب‌سایت، متعلق به شرکت <a className="text-red-600 font-bold" href="https://asredade.com">عصرداده</a> می باشد.</p>
            </div>
        </Container>


    </div>
}
export default EstateReports;